import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { HeartIcon, HeartFilledIcon } from '../../assets';
import { theme } from '../../theme';

const animationDuration = 200;

type WatchButtonProps = {
  width?: number;
  lotId?: number;
  onClick?: (lotId: number, isWatching: boolean) => boolean;
  filled: boolean;
};

const StyledBorder = styled.div<{ width: number }>`
  width: ${({ width }) => width}px;
  height: ${({ width }) => width}px;
  border-radius: 100%;

  display: flex;
  justify-content: center;
  align-items: center;
  background: ${theme.colors.primary.white};
  box-shadow: 0px 2px 4px 0px ${theme.colors.neutrals.transparentGrays[6]};

  flex: none;
  order: 0;
  flex-grow: 0;
  cursor: pointer;
`;

const StyledHeartFilledIcon = styled(HeartFilledIcon).attrs({
  fill: `${theme.colors.system.systemBlue}`,
})<{ width: number }>`
  transition: all ${animationDuration}ms ease-in-out;
  &:hover {
    transform: scale(1.1);
  }
`;

const StyledHeartIcon = styled(HeartIcon).attrs({
  fill: `${theme.colors.system.systemBlue}`,
})`
  transition: all ${animationDuration}ms ease-in-out;
  &:hover {
    transform: scale(1.1);
  }
`;

export const WatchButton: React.FC<WatchButtonProps> = ({
  width = 32,
  lotId,
  onClick,
  filled,
}) => {
  const [isFilled, setIsFilled] = useState(filled);

  // update when/if filled changes
  useEffect(() => {
    setIsFilled(filled);
  }, [filled]);

  const handleClick = (e: React.MouseEvent<HTMLDivElement>) => {
    e.preventDefault();
    if (onClick && lotId && onClick(lotId, !isFilled)) {
      e.stopPropagation();
      setIsFilled(!isFilled);
    }
  };

  return (
    <StyledBorder width={width} onClick={handleClick}>
      {isFilled ? (
        <StyledHeartFilledIcon
          width={(width * 3) / 4}
          height={(width * 3) / 4}
        />
      ) : (
        <StyledHeartIcon width={(width * 3) / 4} />
      )}
    </StyledBorder>
  );
};
